import { render, staticRenderFns } from "./DocumentsList.vue?vue&type=template&id=7e6eaa96&"
import script from "./DocumentsList.vue?vue&type=script&lang=js&"
export * from "./DocumentsList.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsList.vue?vue&type=style&index=0&id=7e6eaa96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports